import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { EndpointService, Logger } from '@app/core';
import { MostrarSuspensionTiempo, SuspensionTiempoApi, Tarea } from '@app/shared';

const log = new Logger('TimeSuspensionsComponent');
@Injectable()
export class TimeSuspensionsDataService {

  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) { }


  /**
   * Carga informacion de las suspensiones
   *
   * @param {number} id
   * @return {*}  {Observable<MostrarSuspensionTiempo[]>}
   * @memberof TimeSuspensionsDataService
   */
  getTimeSuspensionsDetail(id: number): Observable<MostrarSuspensionTiempo[]> {
    return this.http.get<MostrarSuspensionTiempo[]>(this.api.get('adminTimeSuspensions', [id]));
  }


  /**
   * Agrega una suspension de tiempo
   *
   * @param {SuspensionTiempoApi} timeSuspension
   * @return {*}  {Promise<boolean>}
   * @memberof TimeSuspensionsDataService
   */
  addTimeSuspension(timeSuspension: SuspensionTiempoApi): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler().post<boolean>(this.api.get('adminTimeSuspensions'), timeSuspension).subscribe(
        resp => {
          this.toastr.success('Operación exitosa', 'Informacion de la suspensión de tiempo agregada correctamente');
          resolve(true);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          reject(err);
        }
      );
    });
  }



  /**
   * actualiza una suspension de tiempo
   *
   * @param {number} id
   * @param {SuspensionTiempoApi} timeSuspension
   * @return {*}  {Promise<boolean>}
   * @memberof TimeSuspensionsDataService
   */
  updateTimeSuspension(id: number, timeSuspension: SuspensionTiempoApi): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler().put<boolean>(this.api.get('adminTimeSuspensions', [id]), timeSuspension).subscribe(
        resp => {
          this.toastr.success('Operación exitosa', 'Informacion de la suspensión de tiempo modificada correctamente');
          resolve(true);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          reject(err);
        }
      );
    });
  }



  /**
   * Elimina una suspension de tiempo
   *
   * @param {number} id
   * @return {*}  {Promise<boolean>}
   * @memberof TimeSuspensionsDataService
   */
  deleteTimeSuspension(id: number): Promise<boolean> {
     return new Promise((resolve, reject) => {
      this.http.skipErrorHandler().delete<boolean>(this.api.get('adminTimeSuspensions', [id])).subscribe(
        resp => {
          this.toastr.success('Operación exitosa', 'Informacion de la suspensión de tiempo eliminada correctamente');
          resolve(true);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          reject(err);
        }
      );
    });
  }

  /**
   * Consulta una tarea predeterminada en especifico con el id de la tarea
   *
   * @param {number} idTask
   * @return {*}  {Promise<Tarea>}
   * @memberof TimeSuspensionsDataService
   */
   getTask(idTask: number): Promise<Tarea> {
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler()
        .get<Tarea>(this.api.get('defaultTask', [idTask]))
        .subscribe(
          task => {
            resolve(task);
          },
          err => {
            reject(null);
            log.debug(err);
          }
        );
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-automation/time-control/time-suspensions/shared/time-suspensions.data.service.ts